// import Refine from './refine';
//
// $(() => {
//     // ToDo: if we don't use refine, then we don't need this
//     if ($('#refine').length !== 0) {
//         const refine = new Refine();
//     }
// });


const SimpleLightbox = require('simple-lightbox');

// auto submit when a form's select was changed
(function formAutoSelect() {
    const forms = document.querySelectorAll('form.is-autoselect');
    forms.forEach((form) => {
        const button = form.querySelector('button');
        button.parentNode.removeChild(button);
        const select = form.querySelector('select');
        select.addEventListener('change', function filterSelect() {
            this.form.submit();
        });
    });
}());

// open and close the mobile burger menu
(function toggleMobileMenu() {
    const burger = document.querySelector('.burger');
    const navi = document.querySelector('.mtx-navigation');
    burger.addEventListener('click', () => {
        navi.classList.toggle('is-open');
    });
}());

// handle delete button in notifications
(function notificationClose() {
    const closers = document.querySelectorAll('.notification .is-delete');
    closers.forEach(closer => closer.addEventListener('click', function closeClick() {
        this.parentNode.parentNode.removeChild(this.parentNode);
    }));
}());

// handle delete screenshots in editing products
(function initDeleteScreenshotListeners() {
    const deleters = document.querySelectorAll('.js-screenshot-preview .js-is-delete');
    deleters.forEach(deleter => deleter.addEventListener('click', async (e) => {
        const { endpoint } = e.target.dataset;
        if (window.confirm('Really delete Screenshot?')) { // eslint-disable-line no-alert
            const response = await fetch(
                endpoint,
                {
                    method: 'DELETE',
                    credentials: 'include',
                },
            );
            const HTTP_NO_CONTENT = 204;
            if (response.status === HTTP_NO_CONTENT) {
                e.target.parentNode.parentNode.removeChild(e.target.parentNode);
            }
        }
    }));
}());

// add tooltips
(function tooltipInit() {
    const xOffset = 20;
    const ttip = document.createElement('div');
    ttip.className = 'mtx-tooltip';
    ttip.style.display = 'none';
    document.body.insertBefore(ttip, document.body.firstChild);

    const tips = document.querySelectorAll('[data-tooltip]');
    tips.forEach((tip) => {
        tip.addEventListener('mouseenter', (e) => {
            const rect = e.target.getBoundingClientRect();
            ttip.style.left = `${rect.left + xOffset}px`;
            ttip.style.top = `${rect.top + rect.height + window.scrollY}px`;
            ttip.innerText = e.target.getAttribute('data-tooltip');
            ttip.style.display = 'block';
        });
        tip.addEventListener('mouseleave', () => {
            ttip.innerText = '';
            ttip.style.display = 'none';
        });
    });
}());

/* safari bug: does not give focus event on click  */
(function sfFocusBugWorkaround() {
    const mdInputs = document.querySelectorAll('input.md');
    mdInputs.forEach(mdInput => mdInput.addEventListener('change', async (e) => {
        const that = e.target;
        that.focus();
    }));
}());

// toggle consultant details on product detail page
(function productConsultant() {
    const consultants = document.querySelectorAll('.mtx-product-consultants .consultant');
    consultants.forEach(consultant => consultant.addEventListener('click', () => {
        const detail = consultant.querySelector('.detail');
        const current = detail.classList.contains('is-open');
        // close all
        document.querySelectorAll('.mtx-product-consultants .consultant .detail').forEach(
            c => c.classList.remove('is-open'),
        );
        // open if was closed before
        if (!current) detail.classList.add('is-open');
    }));
}());

// make the groups in the product table collapsible and store state in local storage
(function toggleFeatureGroups() {
    const headers = document.querySelectorAll('thead[data-toggle]');
    headers.forEach((header) => {
        const ident = header.dataset.toggle;
        const body = header.parentNode.querySelector(`tbody[data-toggle='${ident}']`);

        // restore stored state
        if (window.localStorage.getItem(ident)) {
            body.classList.add('is-hidden');
        }

        // add click handler
        header.addEventListener('click', (e) => {
            // ignore clicks on header links
            if (e.target.tagName === 'A') return;

            const washidden = body.classList.contains('is-hidden');
            body.classList.toggle('is-hidden');
            if (washidden) {
                window.localStorage.removeItem(ident);
            } else {
                window.localStorage.setItem(ident, true);
            }
        });
    });
}());

// initialize screenshot lightbox
new SimpleLightbox({ elements: '.mtx-show-screenshots a' }); // eslint-disable-line no-new
